// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jyibuozfdxmwcjrfmbxx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp5aWJ1b3pmZHhtd2NqcmZtYnh4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2NDk5NDUsImV4cCI6MjA2ODIyNTk0NX0.r4m55c5lbXCgpxGVWoRKPuhMykgbxaaFxygU_C9dhh0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});